import type { FaireProductEntity } from "../../entity_types/product";

export const p_yeeg7p39g3: FaireProductEntity = {
  token: "p_yeeg7p39g3",
  type: "product",
  name: "Millie Moo GOWN Bamboo Newborn Farm Clothing Home Outfit",
  brandToken: "b_8fs23t2a",
  brandName: "Gigi and Max",
  imageUrl: "https://cdn.faire.com/fastly/7386aaa25e51c423acbac51d6914743748c4121055dbfd66f4da109603365fb6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f9fa446186999a31ef58a1ad3850cf7eafc74fa96c97a90e4d1b8048f97583f.png",
    "https://cdn.faire.com/fastly/b8f1d792ff1966e8d3d166e0eeed7d8eaac31778e1cc63f3be830f860c412d9f.png"
  ],
  priceDollars: 15,
  description: "This listing is for a Newborn Sized super soft and stretchy knotted baby gown. Matching headband can be purchased along with the gown in the dropdown of this listing.\n\nThis gown is size Newborn and fits best on brand new babes up to 3m size (up to 12lbs). The fabric we used is super stretchy, made from bamboo viscose, wait until you feel how soft it is!\n\nCoordinating buttons and the slits at the shoulder make taking on and off baby from the top down very easy! Knot on the gown can be tied and untied as needed for quick diaper changes!\n\nMitten cuff on arm keeps baby from scratching.\n\nHelpful tip : For our models, I knotted the gown first, then slipped them into it feet first, as to not upset baby with pulling the whole gown over their face first.\n\n95% Viscose from Bamboo, 5% Spandex\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:23.462Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
